import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=9974507c&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=9974507c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9974507c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9974507c')) {
      api.createRecord('9974507c', component.options)
    } else {
      api.reload('9974507c', component.options)
    }
    module.hot.accept("./orders.vue?vue&type=template&id=9974507c&scoped=true&", function () {
      api.rerender('9974507c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/orders.vue"
export default component.exports